import React from 'react';
import {Link} from 'gatsby'

const FeaturedServices = () => {
    return (
        <section className="featured-services-area pt-100 pb-70">
            <div className="container">
                <div className="section-title">
                    <h2>How We Take Your Business From Good To Great</h2>
                    <p>Building a business takes time — a ‘great business’ today however requires a strategic vision and focus in the right areas. We can help you discover how your business can create ‘greatness’ in the process.</p>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-featured-services-box">
                            <div className="icon">
                                <i className="flaticon-analysis"></i>
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    Analyze Your Software Needs
                                </Link>
                            </h3>
                            <p>Every project we do begins with careful requirement analysis because it affects all phases of our progress. If it's not well-done, it will more likely create mistakes in later phases.</p>

                            <Link to="/service-details" className="read-more-btn">
                                <i className="flaticon-right"></i> Read More
                            </Link>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-featured-services-box">
                            <div className="icon">
                                <i className="flaticon-structure"></i>
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    Develop A Customized Plan
                                </Link>
                            </h3>
                            <p>After working closedly with our customers, we can then develop a solutions map to outline a range of alternatives. The purpose is to identify several options before settling on a final solution.</p>
                            
                            <Link to="/service-details" className="read-more-btn">
                                <i className="flaticon-right"></i> Read More
                            </Link>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                        <div className="single-featured-services-box">
                            <div className="icon">
                                <i className="flaticon-idea"></i>
                            </div>
                            <h3>
                                <Link to="/service-details">
                                    Implement Your Solution
                                </Link>
                            </h3>
                            <p>Implement the project plan which abides by the key elements, scope, objectives, deliverables, risks, and deadlines.</p>
                            
                            <Link to="/service-details" className="read-more-btn">
                                <i className="flaticon-right"></i> Read More
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FeaturedServices;